import { render } from "./AddRecreationForm.vue?vue&type=template&id=16a3592a"
import script from "./AddRecreationForm.vue?vue&type=script&lang=js"
export * from "./AddRecreationForm.vue?vue&type=script&lang=js"

import "./AddRecreationForm.vue?vue&type=style&index=0&id=16a3592a&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "16a3592a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16a3592a', script)) {
    api.reload('16a3592a', script)
  }
  
  module.hot.accept("./AddRecreationForm.vue?vue&type=template&id=16a3592a", () => {
    api.rerender('16a3592a', render)
  })

}

script.__file = "src/components/recreation/AddRecreationForm.vue"

export default script